import { useAuth, useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useGetSupervisorEncountersQuery } from '../api/supervisorQueueApiSlice';
import { selectBatchId, selectProjectId } from '../state/selector';

export const useSupervisorTaskDataGridFetch = (
  _searchParams?: string
): ReturnType<typeof useGetSupervisorEncountersQuery> => {
  const projectId = useAppSelector(selectProjectId);
  const batchId = useAppSelector(selectBatchId);
  const { user } = useAuth();

  return useGetSupervisorEncountersQuery(
    {
      projectId: projectId || '',
      batchId: batchId || '',
    },
    {
      skip: (!user.isUser && !user.isAdmin) || !projectId || !batchId,
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
    }
  );
};
